/** Local replacement for @reflact/ngx-forms' NgxForm namespace — only the field types actually used in this app. */
export namespace NgxForm {
  export type FormFieldType = 'text' | 'switch' | 'select' | 'multiselect' | 'picklist' | 'template';

  export type AllFormFieldOptions = {
    [key: string]: any;
    selectValues?: any[];
    bindLabel?: string;
    bindValue?: string;
    preserveUnlistedValues?: boolean;
    readonlyTargetValues?: (data: any) => any[];
    template?: any;
    optionTemplate?: any;
    labelTemplate?: any;
    /** Überschriften der beiden PickList-Spalten (links = verfügbar, rechts = ausgewählt). */
    sourceHeader?: string;
    targetHeader?: string;
    /** Bootstrap-Grid-Klasse (z.B. 'col-md-6'), um Felder nebeneinander statt untereinander
     * anzuordnen. Fällt auf volle Breite ('col-12') zurück, wenn nicht gesetzt. */
    widthClass?: string;
  };

  export type FormField = {
    fieldName: string;
    type: FormFieldType;
    label?: string;
    required?: boolean;
    readonly?: boolean;
    /** Ordnet das Feld einem Tab zu, sofern der Aufrufer `FormComponent.tabs` nutzt (siehe
     * form.component.ts#getFieldsForTab) — ohne `tabs`-Input hat dieses Feld keinen Effekt. */
    tab?: string;
    options?: AllFormFieldOptions;
  };

  export type TranslatedLabels = Map<string, string>;
}

/** Reads a possibly dot-separated path (e.g. "globalUser.email") off an object. */
export function getDeep(obj: any, path: string): any {
  return path.split('.').reduce((acc, key) => acc?.[key], obj);
}

/** Writes a possibly dot-separated path (e.g. "globalUser.email") on an object, creating intermediate objects as needed. */
export function setDeep(obj: any, path: string, value: any): void {
  const keys = path.split('.');
  const lastKey = keys.pop()!;
  const target = keys.reduce((acc, key) => (acc[key] ??= {}), obj);
  target[lastKey] = value;
}

/** Local replacement for @reflact/ngx-forms' convertTranslatedLabelsToDatasupply, used to feed rag-datasupply table column labels. */
export function convertTranslatedLabelsToDatasupply(translatedLabels: NgxForm.TranslatedLabels): { fieldName: string; translated: string }[] {
  return Array.from(translatedLabels.entries()).map(([fieldName, translated]) => ({ fieldName, translated }));
}
